var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.mostrarHistoricos }
              },
              [
                _c("i", { staticClass: "fa fa-history" }),
                _c("span", [_vm._v("Historial")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field select" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.estado,
                      expression: "form.estado"
                    }
                  ],
                  attrs: { name: "estado", id: "estado" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "estado",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "T" } }, [_vm._v("Todas")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "P" } }, [
                    _vm._v("Pendientes")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "I" } }, [
                    _vm._v("Iniciadas")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "F" } }, [
                    _vm._v("Finalizadas")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "C" } }, [
                    _vm._v("Canceladas")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "A" } }, [_vm._v("Anuladas")])
                ]
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "estado" } }, [_vm._v("Estado")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field select2" }, [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    placeholder: "Seleccione...",
                    id: "ruta_id",
                    options: _vm.rutas,
                    label: "descripcion"
                  },
                  on: { search: _vm.onSearchRuta, input: _vm.inputRuta },
                  model: {
                    value: _vm.selectedRuta,
                    callback: function($$v) {
                      _vm.selectedRuta = $$v
                    },
                    expression: "selectedRuta"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "ruta_id" } }, [_vm._v("Ruta")])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field select2" }, [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    placeholder: "Seleccione...",
                    id: "supervisor_id",
                    options: _vm.supervisores,
                    label: "nombre"
                  },
                  on: {
                    search: _vm.onSearchSupervisores,
                    input: _vm.inputSupervisor
                  },
                  model: {
                    value: _vm.selectedSupervisor,
                    callback: function($$v) {
                      _vm.selectedSupervisor = $$v
                    },
                    expression: "selectedSupervisor"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "supervisor_id" } }, [
                  _vm._v("Supervisor")
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field select2" }, [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    placeholder: "Seleccione...",
                    id: "verificador_id",
                    options: _vm.verificadores,
                    label: "descripcion"
                  },
                  on: {
                    search: _vm.onSearchVerificadores,
                    input: _vm.inputVerificador
                  },
                  model: {
                    value: _vm.selectedVerificador,
                    callback: function($$v) {
                      _vm.selectedVerificador = $$v
                    },
                    expression: "selectedVerificador"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "verificador_id" } }, [
                  _vm._v("Verificador")
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field select2" }, [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    placeholder: "Seleccione...",
                    id: "recaudador_id",
                    options: _vm.recaudadores,
                    label: "nombre"
                  },
                  on: {
                    search: _vm.onSearchRecaudadores,
                    input: _vm.inputRecaudador
                  },
                  model: {
                    value: _vm.selectedRecaudador,
                    callback: function($$v) {
                      _vm.selectedRecaudador = $$v
                    },
                    expression: "selectedRecaudador"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "recaudador_id" } }, [
                  _vm._v("Recaudador")
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field select" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_fecha,
                      expression: "form.tipo_fecha"
                    }
                  ],
                  attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "tipo_fecha",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "P" } }, [
                    _vm._v("Personalizada")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipo_fecha" } }, [
                _vm._v("Tipo de fecha")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.form.tipo_fecha === "P",
                expression: "form.tipo_fecha === 'P'"
              }
            ],
            staticClass: "col-xs-12 col-md-4"
          },
          [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "datepicker-field" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      id: "desde",
                      locale: "es",
                      "only-date": "",
                      "no-label": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD",
                      formatted: "YYYY-MM-DD",
                      label: "Seleccione fecha..."
                    },
                    model: {
                      value: _vm.form.desde,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "desde", $$v)
                      },
                      expression: "form.desde"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Desde")])
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.form.tipo_fecha === "P",
                expression: "form.tipo_fecha === 'P'"
              }
            ],
            staticClass: "col-xs-12 col-md-4"
          },
          [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "datepicker-field" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      id: "hasta",
                      locale: "es",
                      "only-date": "",
                      "no-label": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD",
                      formatted: "YYYY-MM-DD",
                      label: "Seleccione fecha..."
                    },
                    model: {
                      value: _vm.form.hasta,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "hasta", $$v)
                      },
                      expression: "form.hasta"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Hasta")])
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field select" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.dia_cobro,
                      expression: "form.dia_cobro"
                    }
                  ],
                  attrs: { id: "dia_cobro" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "dia_cobro",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("Todos")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "1" } }, [_vm._v("Lunes")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "2" } }, [_vm._v("Martes")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "3" } }, [
                    _vm._v("Miércoles")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "4" } }, [_vm._v("Jueves")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "5" } }, [_vm._v("Viernes")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "6" } }, [_vm._v("Sábado")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "7" } }, [_vm._v("Domingo")])
                ]
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "dia_cobro" } }, [
                _vm._v("Día de cobro")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field select" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.bodega_id,
                      expression: "form.bodega_id"
                    }
                  ],
                  attrs: { name: "bodega", id: "bodega" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "bodega_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("Todas")]),
                  _vm._v(" "),
                  _vm._l(_vm.bodegas, function(bodega) {
                    return _c(
                      "option",
                      { key: bodega.id, domProps: { value: bodega.id } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(bodega.descripcion) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "bodega" } }, [_vm._v("Sucursal")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("k-table", {
        ref: "listaVisitas",
        attrs: {
          params: _vm.form,
          estadoCancelado: "A",
          estadoAutorizado: "F",
          buscarButton: false,
          filterStatus: false,
          path: _vm.path,
          createButton: false,
          editButton: false,
          deleteButton: false,
          buttons: [
            {
              event: "exportarVisitas",
              icon: "fa-file-excel-o",
              class: "btn-success btn--text"
            }
          ],
          columns: [
            {
              display: "Sucursal",
              value: "ruta.bodega.descripcion"
            },
            {
              display: "Fecha",
              value: "fecha"
            },
            {
              display: "Ruta",
              value: "descripcion_ruta"
            },
            {
              display: "Supervisor",
              value: "nombre_supervisor"
            },
            {
              display: "Verificador",
              value: "descripcion_verificador"
            },
            {
              display: "Recaudador",
              value: "nombre_recaudador"
            },
            {
              display: "Día de cobro",
              value: "descripcion_dia_cobro"
            },
            {
              display: "Creador",
              value: "creador.nombre"
            },
            {
              display: "Creación",
              value: "created_at"
            },
            {
              display: "Modificador",
              value: "modificador.nombre"
            },
            {
              display: "Modificación",
              value: "updated_at"
            },
            {
              display: "Observación",
              value: "observacion"
            },
            {
              display: "Estado",
              value: "descripcion_estado"
            }
          ]
        },
        on: {
          seleccionar: _vm.seleccionarVisita,
          exportarVisitas: _vm.exportarVisitas
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _c(
          "button",
          {
            staticClass: "btn-danger btn--text",
            attrs: { type: "button" },
            on: { click: _vm.cerrar }
          },
          [
            _c("i", { staticClass: "fa fa-times" }),
            _c("span", [_vm._v("Cerrar")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "historicos",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [_c("reportes-historicos-excel", { attrs: { tipoReporte: "vta" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Listado de visitas")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb73169e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb73169e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/visitas/ListaVisitas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cb73169e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/visitas/ListaVisitas.vue
// module chunks = 0